<script setup lang="ts">
import { useI18n } from 'vue-i18n'

withDefaults(defineProps<{ label?: string }>(), {})
const { t } = useI18n()
</script>

<template>
  <!-- Three dots that rise in turn: lighter than a turning arrow (they rest when animations are reduced). -->
  <span role="status" class="inline-flex items-center gap-2 text-[13px] text-muted-foreground">
    <span aria-hidden="true" class="inline-flex items-end gap-[3px]">
      <span v-for="i in 3" :key="i" class="h-1.5 w-1.5 rounded-pill bg-primary/70 motion-dot" :style="{ animationDelay: `${(i - 1) * 140}ms` }" />
    </span>
    {{ label ?? t('common.loading') }}
  </span>
</template>
